import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/u355215173/domains/save-lifes.org/hbuilds/source/repository/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["MarketingHeader","MarketingFooter"] */ "/home/u355215173/domains/save-lifes.org/hbuilds/source/repository/src/components/marketing/MarketingLayout.tsx");
